import type { SimpleTableColumn } from "../../../../components/common/simple-table";
import type { ProductRequestDto } from "../../../../api";
import { Text } from "../../../../components/common/typography";
import { Button } from "../../../../components/common/button";
import { statusChip, formatDate } from "../../utils";

function totalStock(r: ProductRequestDto) {
  return (r.variants ?? []).reduce((sum, v) => sum + (v.quantity ?? 0), 0);
}

export function buildUserProductRequestsColumns(
  onView: (id: string) => void,
  categoryLabel: (categoryId: number | null | undefined) => string | undefined,
): SimpleTableColumn<ProductRequestDto>[] {
  return [
    {
      key: "product",
      label: "Product",
      className: "flex-[3] min-w-0",
      render: (r) => <Text variant="bodyBold" tone="dark">{r.name}</Text>,
    },
    {
      key: "category",
      label: "Category",
      className: "flex-[1.5]",
      render: (r) => (
        <Text variant="body" tone="body">{categoryLabel(r.categoryId) ?? "—"}</Text>
      ),
    },
    {
      key: "id",
      label: "ID",
      className: "flex-[1.5]",
      render: (r) => <Text variant="body" tone="body">{r.supplierId}</Text>,
    },
    {
      key: "stock",
      label: "Stock",
      className: "flex-1",
      render: (r) => (
        <Text variant="body" tone="body">{totalStock(r) || "—"}</Text>
      ),
    },
    {
      key: "date",
      label: "Date",
      className: "flex-[1.5]",
      render: (r) => (
        <Text variant="body" tone="body">{r.createdAt ? formatDate(r.createdAt) : "—"}</Text>
      ),
    },
    {
      key: "status",
      label: "Status",
      className: "flex-[1.5] flex justify-center",
      render: (r) => statusChip(r.status),
    },
    {
      key: "actions",
      label: "Actions",
      className: "flex-1 flex justify-end",
      render: (r) => (
        <Button
          variant="underlinedGhost"
          size="sm"
          className="!px-0"
          onClick={(e) => { e.stopPropagation(); onView(r.id); }}
        >
          View
        </Button>
      ),
    },
  ];
}
